import { _ as _export } from '../internals/export.js';
import { h as hasOwnProperty_1 } from '../internals/has-own-property.js';

var $ = _export;
var hasOwn = hasOwnProperty_1;

// `Object.hasOwn` method
// https://tc39.es/ecma262/#sec-object.hasown
$({ target: 'Object', stat: true }, {
  hasOwn: hasOwn
});
